export default __webpack_public_path__ + "static/media/cc.7375ca01.svg";